module.exports = __webpack_public_path__ + "static/media/email.9665a536.png";